import React, { ReactNode, createContext } from "react";
import {
  KeyboardNavigationContextDefaultValue,
  KeyboardNavigationContextValue,
} from "../types/keyboardNavigation";

export const KeyboardNavigationContext =
  createContext<KeyboardNavigationContextValue>(
    KeyboardNavigationContextDefaultValue
  );

export const KeyboardNavigationProvider: React.FC<{
  navigationMap: string[][];
  columnMajor?: boolean;
  children?: ReactNode;
}> = ({ children, navigationMap, columnMajor = false }) => {
  return (
    <KeyboardNavigationContext.Provider value={{ navigationMap, columnMajor }}>
      {children}
    </KeyboardNavigationContext.Provider>
  );
};
